import React, { Component } from 'react';
import { get } from 'lodash';
import dompurify from 'dompurify';
import Chart from 'components/Chart';
import colors from 'constants/colors';

const renderTooltip = params => {
  const { loading, responses, x, point } = params;
  if (loading) return '<div class="Spinner Spinner--darker" />';
  const getTextOrSubject = response => {
    return dompurify.sanitize(response.text || response.subject);
  };
  return (
    `<span class="OnDemandPracticeEngagementOverviewGraph--tooltip"><b>
        <div class="OnDemandPracticeEngagementOverviewGraph--tooltip--container">
          ${`Interaction ${x}`.toUpperCase()}</b><br/>
          <div class="OnDemandPracticeEngagementOverviewGraph--tooltip--name">
            ${dompurify.sanitize(get(point, 'options.name', ''))}
          </div>` +
    responses
      .map(r => {
        if (!r.deleted) {
          return r.correct
            ? `<span class="d-fi w-fill jc-sb ai-c">
              <span>
                <svg name="check" ref="el" class="Icon c-green is-16">
                  <use xlink:href="#icons-check" />
                </svg>
                ${getTextOrSubject(r) || ''}
              </span>
              <span class="fw-b c-green ml-4">
                ${r.percentSelectedFirst}%
              </span>
            </span>`
            : `<span class="d-fi w-fill jc-sb">
              <span>
                <svg name="remove" ref="el" class="Icon c-red is-16">
                  <use xlink:href="#icons-remove" />
                </svg>
                ${getTextOrSubject(r) || ''}
              </span>
              <span class="fw-b c-red ml-4">
                ${r.percentSelectedFirst}%
              </span>
            </span>`;
        }
        return `<span class="d-fi w-fill jc-sb ai-c">
              <span>
                ${getTextOrSubject(r) || ''}
              </span>
              <span class="ml-4">
                ${r.percentSelectedFirst}%
              </span>
            </span>`;
      })
      .join('<br>') +
    '</div></span>'
  );
};
class ConversationInteractionPerformanceChart extends Component {
  render() {
    const {
      interactions,
      setHoveredInteractionId,
      loading,
      responsesByInteractionId,
    } = this.props;
    return (
      <Chart
        config={{
          chart: {
            type: 'column',
            height: '25%',
            backgroundColor: colors.GRAY_LIGHTEST,
            plotBackgroundColor: '#fff',
            borderColor: colors.GRAY_LIGHT,
            borderWidth: 1,
            marginRight: 2,
            marginTop: 1,
            spacingLeft: 12,
          },
          legend: {
            enabled: false,
          },
          xAxis: {
            type: 'linear',
            minPadding: 0,
            maxPadding: 0,
            className: 'OnDemandPracticeEngagementOverviewGraph',
            labels: {
              style: {
                fontSize: '16px',
              },
            },
          },
          yAxis: {
            // Have additional height so that the graph looks better
            max: 100,
            // Show only 0, 50, 100 percent ticks
            tickPositioner: () => [0, 50, 100],
            className: 'OnDemandPracticeEngagementOverviewGraph',
            allowDecimals: false,
            endOnTick: false,
            labels: {
              format: '{value}%',
              y: 20,
              style: {
                fontSize: '16px',
              },
            },
          },
          series: [
            {
              data: interactions.map(int => ({
                id: int.id,
                name: int.subject,
                x: int.position,
                y: int.percentCorrectOnFirstAttempt * 100,
              })),
              color: colors.GREEN,
            },
          ],
          plotOptions: {
            series: {
              minPointLength: 3,
            },
          },
          tooltip: {
            useHTML: true,
            borderWidth: 1,
            borderColor: colors.GRAY_LIGHTER,
            borderRadius: 10,
            backgroundColor: '#fff',
            padding: 24,
            outside: true,
            style: {
              width: 300,
            },
            formatter() {
              const hoveredInteraction = get(this.point, 'options.id');
              setHoveredInteractionId(hoveredInteraction);
              return renderTooltip({
                loading,
                responses: responsesByInteractionId[hoveredInteraction] || [],
                x: this.x,
                point: this.point,
              });
            },
          },
        }}
      />
    );
  }
}

export default ConversationInteractionPerformanceChart;
